import { VideoJSPlayer } from 'video.js';

const volumeStep = 0.1;

// return true if an action was performed
export const handleCommonMediaShortcuts = (
  evt: KeyboardEvent,
  playerInstance: VideoJSPlayer | null | undefined,
  closePlayer: () => void,
): boolean => {
  if (!evt.shiftKey || !playerInstance) {
    return false;
  }

  switch (evt.key) {
    case 'ArrowUp':
      playerInstance.volume(playerInstance.volume() + volumeStep);
      return true;
    case 'ArrowDown':
      playerInstance.volume(playerInstance.volume() - volumeStep);
      return true;
    case 'P':
      if (playerInstance.paused()) {
        playerInstance.play();
      } else {
        playerInstance.pause();
      }
      return true;
    case 'M':
      const currentMuteState = playerInstance.muted();
      playerInstance.muted(!currentMuteState);
      return true;
    case 'Escape':
      closePlayer();
      return true;
  }

  return false;
};
